import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Container, BottomArrow, Copy } from './continueReadingButton.styles';

export interface ContinueReadingButtonProps {
  isContinuReadingClicked: boolean;
}

export const ContinueReadingButton = ({ isContinuReadingClicked }: ContinueReadingButtonProps) => (
  <>
    {!isContinuReadingClicked && (
      <Container data-testid="continue-reading-button">
        <BottomArrow />
        <Copy>
          <FormattedMessage id="continueReadingButton.copy" defaultMessage="Continue reading" />
        </Copy>
      </Container>
    )}
  </>
);
